import { Button } from "antd";
import styles from "./Header.module.scss";
import { GenPreviewBloc } from "../GenPreviewBloc";

type FooterProps = {
  bloc: GenPreviewBloc;
};

export function Footer(props: FooterProps) {
  return (
    <div className={styles.footerWrapper}>
      <Button
        type="primary"
        size="large"
        block
        disabled={props.bloc.outputs.value.length === 0}
        onClick={() => props.bloc.makeRealApp()}
      >
        Make it real
      </Button>
    </div>
  );
}
